/**
 * Action Types
 */
export const UPDATE_STATE = 'auto-captura/Theme/UPDATE_STATE';

/**
 * Reducer
 */
const initialState = {
  primario: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATE:
      return {
        ...state,
        primario: action.payload.value,
      };

    default:
      return state;
  }
};

export default reducer;
/**
 * Action Creators
 */
export const updateStateTheme = ({prop, value}) => ({
  type: UPDATE_STATE,
  payload: {prop, value},
});
